<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>
    <input matInput [formControlName]="fieldName" [required]="required" [ngClass]="{'uppercase': uppercase, 'capitalize': capitalize}">
    
    <mat-error *ngIf="getFormControlField()?.hasError('required')">
        {{ 'data-table.validation.field-required' | translate }}
    </mat-error>
        
    <mat-error *ngIf="getFormControlField()?.hasError('length')">
        {{ 'data-table.validation.exact-length' | translate : { length: getFormControlField()?.getError('length')['requiredLength'] } }}
    </mat-error>
    
    <mat-error *ngIf="getFormControlField()?.hasError('minlength')">
        {{ 'data-table.validation.min-length' | translate : { minLength: getFormControlField()?.getError('minlength')['requiredLength'] } }}
    </mat-error>
    
    <mat-error *ngIf="getFormControlField()?.hasError('maxlength')">
        {{ 'data-table.validation.max-length' | translate : { maxLength: getFormControlField()?.getError('maxlength')['requiredLength'] } }}
    </mat-error>
    
    <mat-error *ngIf="getFormControlField()?.hasError('pattern') || getFormControlField()?.hasError('email')">
        {{ 'data-table.validation.reg-exp' | translate }}
    </mat-error>
                
    <mat-error *ngIf="getFormControlField()?.hasError('atLeastOneOf')">
        {{ 'data-table.validation.at-least-one-of' | translate : { field1Label: getFormControlField()?.getError('atLeastOneOf')['field1Label'] | translate | translate, field2Label: getFormControlField()?.getError('atLeastOneOf')['field2Label'] | translate } }}
    </mat-error>
</mat-form-field>